import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import apiFetchInternalRepatriationsTransactionsCreate from '../../api/InternalRepatriationsTransactionsCreateAPI';
import { REPATRIATIONS_TRANSACTIONS_CREATE_REQUEST } from '../actions/types/InternalRepatriationsTransactionsCreateActionsTypes';
import { postRepatriationsTransactionsCreateSuccessActionCreator, postRepatriationsTransactionsCreateFailureActionCreator } from '../actions/InternalRepatriationsTransactionsCreateActions';
import { languageSelector } from '../../../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../../../locales/locales';

function* doInternalRepatriationsTransactionsCreateWorker(action) {
  const lang = yield select(languageSelector);

  try {
    const res = yield call(apiFetchInternalRepatriationsTransactionsCreate, action.payload);
    yield put(postRepatriationsTransactionsCreateSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.internalrepatriationstransactions.create.success'),
    }));
  } catch (error) {
    yield put(postRepatriationsTransactionsCreateFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'notification.internalrepatriationstransactions.create.failure'),
    }));
  }
}

function* doInternalRepatriationsTransactionsCreateWatcher() {
  yield takeLatest(REPATRIATIONS_TRANSACTIONS_CREATE_REQUEST, doInternalRepatriationsTransactionsCreateWorker);
}

export default doInternalRepatriationsTransactionsCreateWatcher;
